import Svg from "react-inlinesvg";

import { T, useT } from "@repo/transifex";
import { cn } from "~/lib/utils";

import { CO2_GRADE_ICONS } from "./co2-grade-icons";
import { CO2_GRADE_COLORS, type CO2Rating } from "./nutrition-climate-utils";

type Co2GradeMarkProps = {
  /** Climate grade A–E. Drives the grade icon and the cell tint. */
  rating: CO2Rating;
  className?: string;
};

/**
 * The "Climate grade A–E" cell: the grade icon (which carries the grade letter)
 * on a cell tinted to match the grade, with the "CO₂" footprint label.
 */
export const Co2GradeMark = ({ rating, className }: Co2GradeMarkProps) => {
  const { tint, text } = CO2_GRADE_COLORS[rating];
  const t = useT();

  return (
    <div
      className={cn(
        "flex shrink-0 flex-col items-center justify-center gap-1.5 rounded-2xl px-5 py-3.5",
        className
      )}
      // Grade colours are data-driven, so they can't be Tailwind classes.
      style={{ backgroundColor: tint }}
      role="img"
      aria-label={t("Climate grade {grade}", { grade: rating })}
    >
      <Svg src={CO2_GRADE_ICONS[rating]} className="size-12" aria-hidden />

      <p className="text-sm font-semibold" style={{ color: text }}>
        <T _str="CO₂" />
      </p>
    </div>
  );
};
